<template>
  <section class="app-main">
    <Navbar></Navbar>
    <div class="app-content">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  name: "ComponentsLayout",
  components: { Navbar, Footer },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>
<style scoped>
.app-main {
  height: auto;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.app-content {
  min-height: calc(100vh - 220px);
}
</style>